import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column'
  },

  items: {
    display: 'flex',
    flexDirection: 'column'
  },

  line: {
    position: 'absolute',
    right: '24px',
    bottom: '9px',
    left: '42px',
    borderTop: `1px solid ${theme.palette.primary.main}`
  },

  addFolderButton: {
    position: 'absolute',
    top: '-11px',
    left: '50%',
    borderRadius: '50%',
    height: '12px',
    color: theme.palette.primary.main,
    transform: 'translateX(-50%)',
    cursor: 'pointer'
  }
}))

export default useStyles
